/** The Suno mobile app's store pages. One copy, so the login page and the Scribe tour agree. */
export const SUNO_IOS_APP_URL =
  "https://apps.apple.com/us/app/suno-software/id6448741301";
export const SUNO_ANDROID_APP_URL = "https://tinyurl.com/ycxfsnpz";
